<mat-checkbox
    #control
    [disabled]="disabled()"
    [ngModel]="value()"
    (change)="valueChanged($event)">
    <span>{{ label() }}</span>
</mat-checkbox>
